import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentDmsEnumValueType on DmsEnumValueType {
    enumId
    isMultiselect
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentDmsEnumValueTypeFragment,
  ents.core.dms.data.Value.Type.Enum
>({
  enumId: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  isMultiselect: graphql.transformers.OUT.default(
    transformers.PASS_THROUGH,
    false,
  ),
})
